import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { RideGrid, RideGlPinSolid } from '@rimac-seguros/ride-system-components';
import useBreakpoint from '../../../hooks/useBreakpoint';

import './styles.scss';

const RbrFooter = ({ authoring }) => {
  const {
    logoMobile,
    logoDesktop,
    altFooter,
    txtFooter,
    address,
  } = authoring;

  const [newText, setNewText] = useState(txtFooter);
  const location = useLocation();
  const isDesktop = useBreakpoint('large-min');

  useEffect(() => {
    const now = new Date();
    const value = newText.replace('[year]', now.getFullYear());
    setNewText(value);
  }, []);

  const hideFooterMobile = useMemo(() => {
    const routes = [
      '/comprar/seguro-salud-flexible/asegurados',
      '/comprar/seguro-salud-flexible/pago',
    ];
    return routes.includes(location.pathname);
  }, [location.pathname]);

  return (
    <section className={`container-footer ${hideFooterMobile ? 'hidden lg:block' : ''} w-full bg-ride-sys-color-background-strong py-ride-gl-spacing-5xlarge`}>
      <RideGrid id="section-footer">
        <div className="flex flex-col items-center col-span-full gap-ride-gl-spacing-4xlarge lg:flex-row lg:items-center lg:justify-between">
          <div className="lg:flex-1">
            <img src={isDesktop ? logoDesktop : logoMobile} alt={altFooter} />
          </div>
          <div className="flex items-center justify-center w-full gap-ride-gl-spacing-large pt-ride-gl-spacing-4xlarge border-t-ride-gl-border-width-thin border-ride-sys-color-border-strong lg:border-t-0 lg:pt-0 lg:flex-1">
            <RideGlPinSolid size={isDesktop ? 'x-large' : 'large'} fill="#FFF" />
            <p className="ride-sys-text-label-small-regular text-ride-sys-color-text-inverse lg:ride-sys-text-label-medium-regular">{address}</p>
          </div>
          <p className="w-full text-center ride-sys-text-paragraph-small-default text-ride-sys-color-text-inverse lg:ride-sys-text-label-medium-regular lg:text-left lg:border-t-0 lg:pt-0 lg:w-max lg:flex lg:flex-1 lg:justify-end">{newText}</p>
        </div>
      </RideGrid>
    </section>
  );
};

RbrFooter.propTypes = {
  authoring: PropTypes.shape({
    logoMobile: PropTypes.string.isRequired,
    logoDesktop: PropTypes.string.isRequired,
    altFooter: PropTypes.string.isRequired,
    txtFooter: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
  }).isRequired,
};

export default RbrFooter;
